<template>
  <div>
    <div>
      <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
      <NavBarOnly></NavBarOnly>
      <div class="conteudo cor-secundaria-bg" style="position: unset;">
        <logo-empresa></logo-empresa>
        <div style="background-color: white; ">
          <p style="margin: 20px;" v-html="this.$store.state.ultimo_pedido_cliente_logado.pedido_html">
          </p>
        </div>
        <center>
        <div class="btn waves-effect waves-light cor-primaria-bg" style="padding: 0; width: 90%"
             @click="ChecarDisponibilidadeProdutosUltimoPedido()">
          <div class="">
            <div class="col s12" style="margin-left: auto; margin-right: auto; font-weight: bold">
              Repetir Pedido
            </div>
          </div>
        </div>
        <div style="height:15px"></div>
        <div class="btn waves-effect waves-light cor-primaria-bg" style="padding: 0;width: 90%"
             @click="IrParaCarrinho()">
          <div class="">
            <div class="col s12" style="margin-left: auto; margin-right: auto; font-weight: bold">
              Voltar para nosso Cardápio
            </div>
          </div>
        </div>
        </center>
        <br>
        <br>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import NavBarOnly from "../../Widgets/NavBarOnly";
import LogoEmpresa from "../../Widgets/LogoEmpresa";
import axios from "axios";
import {
  IncluirNovoAdicionalDaCategoriaNoProduto,
  IncluirNovoAdicionalNoProduto,
  IncluirNovoProduto,
  ObterProdutoParaIncluirNoCarrinho
} from "../../../services/produto";

export default {
  name: "UltimoPedido",
  components: {LogoEmpresa, NavBarOnly, Loading},
  data() {
    return {
      isLoading: false,
      fullPage: true
    }
  },
  async mounted() {
    $("body").css({"overflow": "unset"});
    window.scrollTo(0, 0);
    await this.ObterProdutosDaLoja();
  },
  methods: {
    async ObterProdutosDaLoja() {
      this.isLoading = true;
      let response = await axios.get(this.$store.state.apiUrl + 'empresa/' + this.$store.state.empresa_url + '/grupos/produtos').catch(error => this.isLoading = false);
      this.$store.commit('grupos', response.data)
      this.isLoading = false;
    },
    IrParaCarrinho(){
      this.$router.push("/" + this.$store.state.empresa_url + "/pedido");
    },
    ChecarDisponibilidadeProdutosUltimoPedido() {
      let grupos = this.$store.state.grupos;
      let produtos = [];
      let itens = this.$store.state.ultimo_pedido_cliente_logado.itens;
      this.LimparCarrinho();
      grupos.forEach(grupo => {
        produtos.push(...grupo.produtos);
      });

      itens.forEach(produtoPedido => {

        let resultadoProdutoAtualizado = produtos.filter(produto => produto.id === produtoPedido.produto_id);
        if (resultadoProdutoAtualizado.length > 0) {
          let produtoAtualizado = resultadoProdutoAtualizado[0];
          IncluirNovoProduto(produtoAtualizado.id,
            produtoAtualizado.promocao == 'S' ? produtoAtualizado.valor_promocional : produtoAtualizado.valor,
            produtoAtualizado.somente_retirada,
            produtoAtualizado.nome,
            produtoPedido.observacao_cliente,
            produtoPedido.quantidade,
            produtoAtualizado.permite_cupom_desconto);
          if (produtoPedido.adicionais && produtoPedido.adicionais.length > 0)
          {
            produtoPedido.adicionais.forEach(adicionalPedido => {
              if (produtoAtualizado.categorias.length > 0) {
                let catAd = []
                produtoAtualizado.categorias.forEach(categoria => {
                  if (categoria.adicionais && categoria.adicionais.length > 0) {
                    categoria.adicionais.forEach(res => {
                      let onlyCat = JSON.parse(JSON.stringify(categoria));
                      let adicionalDaCategoria = JSON.parse(JSON.stringify(res));
                      delete onlyCat.adicionais;
                      adicionalDaCategoria.categoria_ref = onlyCat;
                      catAd.push(adicionalDaCategoria);
                    })
                  }
                });
                let categoriaAdicional = catAd.filter(adicional => adicional.adicional_id === adicionalPedido.adicional_id);
                if (categoriaAdicional && categoriaAdicional.length > 0)
                {
                  let categoriaAdicionalDoPedido = adicionalPedido;
                  let categoriaAdicionalDaApi = categoriaAdicional[0];
                  categoriaAdicionalDaApi.quantidade = categoriaAdicionalDoPedido.adicional_quantidade - 1;
                  IncluirNovoAdicionalDaCategoriaNoProduto(categoriaAdicionalDaApi.categoria_ref, categoriaAdicionalDaApi,this.$store.state.empresa.pizza_maior_preco);
                }
              }

              if (produtoAtualizado.adicionais.length > 0) {
                  let categoriaAdicional = produtoAtualizado.adicionais.filter(adicional => adicional.adicional_id === adicionalPedido.adicional_id);
                  if (categoriaAdicional && categoriaAdicional.length > 0)
                  {
                    let categoriaAdicionalDoPedido = adicionalPedido;
                    let categoriaAdicionalDaApi = categoriaAdicional[0];
                    categoriaAdicionalDaApi.quantidade = categoriaAdicionalDoPedido.adicional_quantidade - 1;
                    IncluirNovoAdicionalNoProduto(categoriaAdicionalDaApi);
                  }
              }


            })
          }
          this.EnviarProdutoParaCarrinho(ObterProdutoParaIncluirNoCarrinho())
        } else {
          M.toast({ html: "Produto indisponivel: " + produtoPedido.produto_nome, displayLength: 3000 });
        }
      });
    },
    LimparCarrinho(){
      this.$store.commit("pedido",{
        itens: []
      });
    },
    EnviarProdutoParaCarrinho(produto){
      this.$store.commit("adicionar_item_pedido", produto);
      this.IrParaCarrinho();
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Paginas/AreaCliente/UltimoPedido.vue